import { Typography, Grid, Box, useMediaQuery, useTheme, Link } from '@mui/material';
import { useCallback } from 'react';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useTranslation } from 'react-i18next';
import { ICON_BASE_PATH, IMAGE_BASE_PATH } from '../../config/paths';

const ProjetoVivo = () => {
    const { t } = useTranslation();

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isXXLScreen = useMediaQuery(theme.breakpoints.up('xl'));

    const manageFlagIcons = useCallback((pais: string) => {
        switch (pais) {
            case "ALEMANHA":
                return <img src={`${ICON_BASE_PATH}GermanIcon.svg`} alt="My Icon" style={{ width: '36px', height: '36px' }} />
            default:
                return <img src={`${ICON_BASE_PATH}BrazilIcon.svg`} alt="My Icon" style={{ width: '36px', height: '36px' }} />
        }
    }, [])

    const textoDescritivoStyle = {
        fontFamily: 'Roboto, sans-serif', 
        fontWeight: 400, 
        lineHeight: 1.7, 
        letterSpacing: '0.02em', 
        fontSize: '1rem', 
        color: 'black',
        textAlign: isSmallScreen ? "center" : "left",
        marginTop: 3
    }

    const textoTituloStyle = {
        fontFamily: 'Oswald, sans-serif', 
        fontWeight: 700, 
        fontSize: {xs:'2.5rem',sm:'2.5rem',md:'1.8rem',lg:'2.5rem',xl:'2.5rem'}, 
        letterSpacing: '-0.05em', 
        textTransform: 'uppercase',
        textAlign: isSmallScreen ? "center" : "left",
    }

    const textoSubTituloStyle = {
        fontFamily: 'Oswald, sans-serif',
        fontWeight: 600, 
        fontSize: {xs:'1.8rem',sm:'1.8rem',md:'1.3rem',lg:'1.8rem',xl:'1.8rem'},
        letterSpacing: '-0.03em', 
        textTransform: 'uppercase',
        textAlign: isSmallScreen ? "center" : "left",
    }

    return (
        <Grid container spacing={4} justifyContent="center" sx={{ backgroundColor: 'white' }}>

            <Grid size={12} height={"80vh"}>
                <Box
                    sx={{
                        position: 'relative',
                        height: '100%',
                        width: '100%',
                        overflow: 'hidden',
                    }}
                >
                    <img
                        src={`${IMAGE_BASE_PATH}projetosocial/ProjetoVivoCriancas.avif`}
                        alt="Imagem 1"
                        style={{ width: "100%", height: "100%", objectFit: 'cover' }}
                    />

                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: { xs: '5%', sm: '5%', md: '5%', lg: '5%', xl: '5%' },
                            left: { xs: '7%', sm: '5%', md: '10%', lg: '10%', xl: '10%' },
                            color: '#fff',
                            textAlign: 'left',
                        }}
                    >
                    </Box>
                </Box>
            </Grid>

            <Grid size={12} direction={"column"} justifyContent={"center"} mt={3} mb={3}>
                <Typography variant="h1" fontSize={{ xs: 45, sm: 65, md: 85, lg: 100, xl: 100 }} 
                sx={{
                    color:"black",
                    textAlign:"center" ,
                    fontFamily: 'Montserrat, sans-serif', 
                    fontWeight: 100, 
                }}>
                {t('PROJETO VIVO')}
                </Typography>
            </Grid>

            <Grid container spacing={4} justifyContent="center" sx={{ display: 'flex', alignItems: 'flex-start', height: '100%', padding: 2 }}>

            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} display="flex" justifyContent={isXXLScreen ? "end" : "center"}>
                    <Box
                        sx={{
                            position: 'relative',
                            height: '100%',
                            width: '100%',
                            maxWidth: '680px',
                            overflow: 'hidden',
                            marginRight: isXXLScreen ? 15 : undefined,
                        }}
                    >
                        <img
                            src={`${IMAGE_BASE_PATH}projetosocial/ProjetoVivoReconhecimento.avif`}
                            alt="Imagem 1"
                            style={{ objectFit: 'cover', width: '100%', height: '100%' }} // Define que a imagem ocupe 100% do box
                        />

                    </Box>
                </Grid>
                
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                        <Box
                            sx={{
                                color: '#fff',
                                textTransform: 'none',
                                maxWidth: isSmallScreen ? '100%' : { xs: '680px', sm: '680px', md: '680px', lg: '680px', xl: '680px' },
                                justifyContent: 'center',
                            }}
                        >
                            <Typography variant="h1" color='black'
                                sx={textoTituloStyle}>
                                {t('Kitesurf Social e Inclusão em Barra Grande:')}
                            </Typography>
                            <Typography variant="h1" color='black'
                                sx={textoSubTituloStyle}>
                                {t('Um Novo Capítulo para o Projeto Vivo')}
                            </Typography>
                            <Typography variant="h1" color='black'
                                sx={textoDescritivoStyle}>
                                    {t('Com mais de 10 anos dedicados à promoção da cidadania e inclusão social por meio do esporte, o Projeto Vivo alcançou um importante reconhecimento. A Associação foi oficialmente declarada de Utilidade Pública pelo Estado do Piauí, conforme a Lei nº 8275, sancionada em 04 de janeiro de 2024.')}
                            </Typography>

                            <Typography variant="h1" color='black'
                                sx={textoDescritivoStyle}>
                                    {t('Atendendo a mais de 100 crianças e jovens nativos de Barra Grande, o Projeto Vivo oferece diversas atividades, como futsal e uma animada escolinha de férias, onde o kitesurf tem grande destaque. Este reconhecimento chega em um momento crucial, trazendo novas oportunidades para a expansão de recursos e melhoria das condições oferecidas às crianças.')}
                            </Typography>

                            <Typography variant="h1" color='black'
                                sx={textoDescritivoStyle}>
                                    {t('Com a declaração de utilidade pública, o Projeto Vivo agora tem prioridade na doação e aquisição de materiais como equipamentos esportivos, computadores e mobiliário. Esses recursos são essenciais para aprimorar as atividades e proporcionar um ambiente ainda mais acolhedor e estruturado para a comunidade local.')}
                            </Typography>

                            <Typography variant="h1" color='black'
                                sx={textoDescritivoStyle}>
                                  {t('O apoio de diversas pessoas e instituições foi fundamental para essa conquista, e o reconhecimento abre caminho para impactar ainda mais vidas na região. O Projeto Vivo continua firme em sua missão de transformar o futuro das crianças de Barra Grande através do esporte e da educação.')}
                            </Typography>
                        </Box>
                    </Grid>

                    {!isMobile && 
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Box
                        sx={{
                            color: '#fff',
                            textTransform: 'none',
                            maxWidth: isSmallScreen ? '100%' : { xs: '680px', sm: '680px', md: '680px', lg: '680px', xl: '680px' },
                            marginLeft: 'auto', // Isso empurra o conteúdo para a direita
                        }}
                    >
                        <Typography variant="h1" color='black'
                            sx={textoTituloStyle}>
                            {t('HISTÓRIAS QUE INSPIRAM')}
                        </Typography>
                        <Typography variant="h1" color='black'
                            sx={textoSubTituloStyle}>
                            {t('TRANSFORMANDO VIDAS ATRAVÉS DO KITESURF')}
                        </Typography>
                        <Typography variant="h1" color='black'
                            sx={textoDescritivoStyle}>
                            {t('Entre as muitas histórias de transformação que apoiamos, uma das mais inspiradoras é a da Bia, que começou sua jornada no kitesurf por meio do')}
                            <Box component="span" sx={{ color: 'green', fontWeight: "bold" }}> PROJETO VIVO KITESURF</Box> {t('voltado para crianças em situação de vulnerabilidade.')}

                        </Typography>

                        <Typography variant="h1" color='black'
                            sx={textoDescritivoStyle}>
                            {t('O esporte não só abriu novas oportunidades, mas também permitiu que ela desenvolvesse uma paixão e uma disciplina que a levaram a competir em campeonatos mundiais de kitesurf.')}
                        </Typography>
                        <Typography variant="h1" color='black'
                            sx={{
                                fontFamily: 'Roboto, sans-serif', // Uma fonte sans-serif comum e legível
                                fontWeight: 400, // Peso regular
                                lineHeight: 1.7, // Espaçamento entre linhas para melhor legibilidade
                                letterSpacing: '0.02em', // Pequeno espaçamento entre letras
                                fontSize: '1rem', // ajuste conforme necessário
                                color: 'black',
                                textAlign: isSmallScreen ? "center" : "left",
                                marginTop: 3
                            }}>
                            {t('Hoje, Bia é um exemplo vivo de como o esporte pode mudar vidas, servindo como inspiração para jovens que enfrentam os mesmos desafios que ela superou. Sua determinação e conquistas refletem o poder de acreditar no próprio potencial e nas oportunidades que surgem quando oferecemos apoio e recursos a quem mais precisa.')}
                        </Typography>
                    </Box>


                </Grid>}

                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} display="flex" justifyContent={isXXLScreen ? "start" : "center"} >
                    <Box
                        sx={{
                            marginLeft: isXXLScreen ? 20 : undefined,                            
                            position: 'relative',
                            height: '100%',
                            width: { xs: '100%', sm: '100%', md: '100%', lg: '100%', xl: '100%' },
                            maxWidth: '400px',
                            overflow: 'hidden',
                        }}
                    >
                        <img
                            src={`${IMAGE_BASE_PATH}projetosocial/BiaKiteSurf.avif`}
                            alt="Imagem 1"
                            style={{
                                objectFit: 'cover', width: '100%', height: '100%',
                                filter: 'blur(0.7px)', // Desfoque leve
                                borderRadius: '8px' // Bordas arredondadas
                            }} // Define que a imagem ocupe 100% do box
                        />

                        <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>

                            <Box display={"flex"}
                                flexDirection={"row"}
                                justifyContent={"center"}>
                                {manageFlagIcons("BRASIL")}
                                <Typography
                                    variant="h6"
                                    component="div"
                                    gutterBottom
                                    sx={{
                                        fontFamily: "Lato, sans-serif",
                                        fontWeight: 400,
                                        color: "black",
                                        marginLeft: 1,
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        marginBottom: 0,
                                    }}
                                >
                                    BIA
                                </Typography>

                            </Box>
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                    fontFamily: "Montserrat, sans-serif",
                                    fontWeight: 500,
                                    color: "grey",
                                    marginTop: -1,
                                }}
                            >
                                BARRA GRANDE - PI
                            </Typography>
                        </Box>
                        <Box
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"center"}
                            sx={{
                                backgroundColor: "#FFDE00",
                                paddingTop: 0.5,
                                paddingBottom: 0.5,
                                marginLeft: "auto",
                                marginRight: "auto",
                                borderRadius: 1,
                                width: "100%", // A barra do Instagram agora tem a mesma largura da imagem
                                maxWidth: "700px",
                                marginTop: "8px", // Espaçamento entre a imagem e a barra do Instagram
                            }}
                        >
                            <InstagramIcon sx={{ color: "black", marginTop: 0.6 }} />
                            <Link
                                href={"https://www.instagram.com/biakitebg/"}
                                target="_blank"
                                underline="none"
                                sx={{ textDecoration: "none" }}
                            >
                                <Typography
                                    variant="body1"
                                    color="text.secondary"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "black",
                                        marginLeft: "8px",
                                    }}
                                >
                                    @biakitebg
                                </Typography>
                            </Link>
                        </Box>
                    </Box>

                </Grid>

                {isMobile && 
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Box
                        sx={{
                            color: '#fff',
                            textAlign: 'center',
                            textTransform: 'none',
                            maxWidth: isSmallScreen ? '100%' : { xs: '680px', sm: '680px', md: '680px', lg: '680px', xl: '680px' },
                        }}
                    >
                        <Typography variant="h1" color='black'
                            sx={textoTituloStyle}>
                            {t('HISTÓRIAS QUE INSPIRAM')}
                        </Typography>
                        <Typography variant="h1" color='black'
                            sx={textoSubTituloStyle}>
                            {t('TRANSFORMANDO VIDAS ATRAVÉS DO KITESURF')}
                        </Typography>
                        <Typography variant="h1" color='black'
                            sx={textoDescritivoStyle}>
                            {t('Entre as muitas histórias de transformação que apoiamos, uma das mais inspiradoras é a da Bia, que começou sua jornada no kitesurf por meio do')}
                            <Box component="span" sx={{ color: 'green', fontWeight: "bold" }}> PROJETO VIVO KITESURF</Box> {t('voltado para crianças em situação de vulnerabilidade.')}

                        </Typography>

                        <Typography variant="h1" color='black'
                            sx={textoDescritivoStyle}>
                            {t('O esporte não só abriu novas oportunidades, mas também permitiu que ela desenvolvesse uma paixão e uma disciplina que a levaram a competir em campeonatos mundiais de kitesurf.')}
                        </Typography>
                        <Typography variant="h1" color='black'
                            sx={{
                                fontFamily: 'Roboto, sans-serif', // Uma fonte sans-serif comum e legível
                                fontWeight: 400, // Peso regular
                                lineHeight: 1.7, // Espaçamento entre linhas para melhor legibilidade
                                letterSpacing: '0.02em', // Pequeno espaçamento entre letras
                                fontSize: '1rem', // ajuste conforme necessário
                                color: 'black',
                                textAlign: isSmallScreen ? "center" : "left",
                                marginTop: 3
                            }}>
                            {t('Hoje, Bia é um exemplo vivo de como o esporte pode mudar vidas, servindo como inspiração para jovens que enfrentam os mesmos desafios que ela superou. Sua determinação e conquistas refletem o poder de acreditar no próprio potencial e nas oportunidades que surgem quando oferecemos apoio e recursos a quem mais precisa.')}
                        </Typography>
                    </Box>


                </Grid>}
            </Grid>

        </Grid>
    );
};

export default ProjetoVivo;